import { cn } from "../utils";

interface BackgroundPatternProps {
  /** Pattern variant */
  variant?: "dots" | "grid" | "waves" | "diagonal";
  /** Pattern opacity */
  opacity?: "light" | "medium" | "bold";
  /** Pattern color */
  color?: "primary" | "secondary" | "accent" | "muted";
  /** Custom className */
  className?: string;
}

const opacityClasses = {
  light: "opacity-5",
  medium: "opacity-10",
  bold: "opacity-20",
};

const colorClasses = {
  primary: "text-primary",
  secondary: "text-secondary",
  accent: "text-accent",
  muted: "text-muted",
};

/**
 * SVG background patterns for adding visual texture
 */
export function BackgroundPattern({
  variant = "dots",
  opacity = "light",
  color = "primary",
  className,
}: BackgroundPatternProps) {
  return (
    <svg
      className={cn(
        "absolute inset-0 h-full w-full pointer-events-none",
        opacityClasses[opacity],
        colorClasses[color],
        className
      )}
      aria-hidden="true"
    >
      {variant === "dots" && (
        <defs>
          <pattern id="dots-pattern" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <circle cx="2" cy="2" r="1" fill="currentColor" />
          </pattern>
        </defs>
      )}
      {variant === "grid" && (
        <defs>
          <pattern id="grid-pattern" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
            <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="1" />
          </pattern>
        </defs>
      )}
      {variant === "diagonal" && (
        <defs>
          <pattern id="diagonal-pattern" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
            <line x1="0" y1="0" x2="0" y2="40" stroke="currentColor" strokeWidth="1" />
          </pattern>
        </defs>
      )}
      {variant === "waves" && (
        <defs>
          <pattern id="waves-pattern" x="0" y="0" width="100" height="20" patternUnits="userSpaceOnUse">
            <path
              d="M0 10 Q 25 0, 50 10 T 100 10"
              fill="none"
              stroke="currentColor"
              strokeWidth="1"
            />
          </pattern>
        </defs>
      )}
      <rect
        width="100%"
        height="100%"
        fill={`url(#${variant}-pattern)`}
      />
    </svg>
  );
}
